import Table from 'react-bootstrap/Table'
export default function TablaCorte({
    data,
    children
}) {
    return (
        <>
            {
                data.length > 0 ? (
                    <Table responsive={'md'} className={"text-center table-row-dashed table-hover gy-5"}>
                        {children}
                    </Table>
                ) : (
                    <div className={"position-relative"} style={{height: "10rem"}}>
                        <div className={"position-absolute top-50 start-50 translate-middle"}>
                            <i className="ki-duotone ki-search-list fs-5hx text-primary">
                                <span className="path1"></span>
                                <span className="path2"></span>
                                <span className="path3"></span>
                            </i>
                        </div>
                        <br/>
                        <span className={"position-absolute bottom-0 start-50 translate-middle-x fw-semibold fs-5"}>Sin datos</span>
                    </div>
                )
            }
        </>
    );
}
